module.exports = __webpack_public_path__ + "img/invalid-name.d8b774f6.svg";